import '@angular/localize/init';
import 'hammerjs';
import 'hammer-timejs';
import 'zone.js';